import { render, staticRenderFns } from "./fiskopyala.vue?vue&type=template&id=43099e4a"
import script from "./fiskopyala.vue?vue&type=script&lang=js"
export * from "./fiskopyala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports